<template>
  <footer class="FooterAbout w">
    <div class="about">
      <div class="title">
        <h2>关于我们</h2>
        <p>———— About Us Brand Of Design————</p>
      </div>
      <div class="about-box">
        <div v-if="position == 2"
             class="about-content">
          <h4>深圳锦龙名车中心</h4>
          <p>Luxury car：<em>KLM</em></p>
          <span>购车热线：15118088395</span>
          <span>营业时间：9:00-18:00</span>
        </div>
        <div v-if="position == 1"
             class="about-content">
          <h4>广州锦龙名中心</h4>
          <p>Luxury car：<em>KLM</em></p>
          <span>购车热线：020-85292590</span>
          <span>营业时间：9:00-18:00</span>
        </div>
        <div class="map">
          <div class="info">点击地图上的点标记，打开详细信息</div>
          <div id="container"
               class="map-amap"></div>
        </div>
        <div class="code">
          <div class="code-img"><img src="../images/web_icon.png" />
            <p>锦龙汽车集团官网</p>
          </div>
          <div class="code-img"><img src="../images/weixin_icon.png" />
            <p>易手车公众号</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import MapLoader from '../js/AMap.js'
import Cookies from 'js-cookie'
import AMapUI from 'AMapUI'


export default {
  name: 'FooterAbout',
  data () {
    return {
      position: Cookies.get('position') || 2
    }
  },
  mounted () {
    let that = this
    let center = []
    let position1 = ''
    let position2 = ''
    let infoTitle = ''
    let infoBody = ''
    if (this.position == 2) {
      center = [113.907964, 22.474976]
      position1 = '113.907964'
      position2 = '22.474976'
      infoTitle = '<strong style="font-size: 14px">深圳锦龙名车中心</strong>'
      infoBody = '<div style="width: 200px;line-height: 16px"><p>地址：深圳市南山区招商街道蛇口港湾大道26号A3</p><p>联系电话：0755-26808950</p><p style="text-align:right; "><a style="color: red" href="http://f.amap.com/1DC7v_0506sXd">导航到店</a></p></div>'
    } else if (this.position == 1) {
      center = [113.413921, 23.133645]
      position1 = '113.413921'
      position2 = '23.133645'
      infoTitle = '<strong style="font-size: 14px">广州锦龙名中心</strong>'
      infoBody = '<div style="width: 200px;line-height: 16px"><p>地址：广州市天河区奥体南路5号</p><p>联系电话：020-85292590</p><p style="text-align:right; "><a style="color: red" href="http://surl.amap.com/6gllJ_0927CED">导航到店</a></p></div>'
    }
    MapLoader().then(AMap => {
      console.log('地图加载成功')
      let map = new AMap.Map('container', {
        resizeEnable: true,
        // dragEnable: false, 禁止拖动
        zoomEnable: true,  //禁止缩放
        zoom: 16,
        center: center
      })
      AMap.plugin('AMap.Marker', function () {
        let marker = new AMap.Marker({
          map: map,
          position: new AMap.LngLat(position1, position2)
        })
        AMap.event.addListener(marker, 'click', (e) => {
          AMapUI.loadUI(['overlay/SimpleInfoWindow'], function (SimpleInfoWindow) {
            var infoWindow = new SimpleInfoWindow({
              infoTitle: infoTitle,
              infoBody: infoBody,
              offset: new AMap.Pixel(0, -20),
              autoMove: true,
              isCustom: true
            })
            infoWindow.open(map, e.target.getPosition())
            // 最坑的就是这一步了，他的infowindow没有点击事件，所以infoWindow.get$Container()会返回这个infowindow（jquery）对象
            // let infoEle = infoWindow.get$Container()
            //给infowindow添加点击事件，并在回调函数中处理业务或者跳转等
            // infoEle.on('click', (e) => {
            //   router.push({name: 'proinfo', params: 'http://www.kamlung.com/'})
            // })
          })
        })
      })
    })
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../css-styl/mixins.styl';

.FooterAbout {
  width: 100%;
  float: left;
  margin-top: 20px;
  background: #000;
  color: #fff;

  .about {
    padding: 30px 0;

    .title {
      text-align: center;
      margin-bottom: 30px;

      h2 {
        font-size: 22px;
      }

      p {
        font-size: 14px;
        margin-top: 8px;
      }
    }

    .about-box {
      vertical-align: top;

      .about-content {
        width: 250px;
        padding: 20px 0 20px 40px;
        vertical-align: top;
        display: inline-block;

        p, span {
          height: 32px;
          line-height: 32px;
        }

        h4 {
          font-family: 'ML';
          font-size: 20px;
          font-weight: 600;
        }

        p {
          font-family: 'BL';
          font-size: 18px;
          line-height: 22px;
          font-weight: 600;
          color: red;
        }

        em {
          font-weight: 600;
        }

        span {
          font-size: 16px;
          display: block;
        }
      }

      .map {
        color: #000;
        position: relative;
        display: inline-block;

        .info {
          width: auto;
          min-width: 22px;
          padding: 6px 16px;
          border-radius: 1px;
          background-color: white;
          border-width: 0;
          box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
          position: absolute;
          top: 4px;
          right: 4px;
          z-index: 999;
        }

        .map-amap {
          width: 560px;
          height: 180px;
          position: relative;
          top: 0px;
          left: 0px;
          z-index: 99;
        }
      }

      .code {
        width: 300px;
        vertical-align: top;
        text-align: right;
        display: inline-block;

        p {
          font-size: 14px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          margin-top: 4px;
        }

        .code-img {
          width: 40%;
          padding: 0 10px;
          display: inline-block;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}

// 底下
@media screen and (min-width: 980px) and (max-width: 1200px) {
  .FooterAbout .about .about-box .map .map-amap {
    width: 460px !important;
  }
}

@media screen and (min-width: 700px) and (max-width: 1100px) {
  .FooterAbout .about .about-box .map .map-amap {
    width: 360px !important;
  }
}

@media screen and (min-width: 700px) and (max-width: 1100px) {
  .FooterAbout .about .about-box .map .map-amap {
    width: 360px !important;
  }
}

@media screen and (min-width: 0) and (max-width: 965px) {
  .FooterAbout .about .about-box {
    text-align: center !important;

    .about-content {
      padding: 40px 0 !important;
    }

    .code {
      width: 100% !important;
      text-align: center !important;
      margin-top: 30px !important;

      .code-img {
        width: 112px !important;
      }
    }
  }
}

@media screen and (min-width: 0px) and (max-width: 700px) {
  .FooterAbout .about .about-box {
    .about-content {
      padding: 10px 0 !important;
    }
  }
}

@media screen and (min-width: 0px) and (max-width: 600px) {
  .FooterAbout .about .about-box .map .map-amap {
    width: 360px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterAbout.vue